(function () {
  var form = document.getElementById('ProductForm');
  var json = document.getElementById('ProductJSON');
  if (!form || !json) return;
  var data = JSON.parse(json.textContent);
  var rate = parseFloat(form.getAttribute('data-rate')) || 0;
  var idInput = document.getElementById('VariantId');
  var btn = document.getElementById('BarBtn');
  var barPrice = document.getElementById('BarPrice');
  var priceBox = document.getElementById('PriceBox');
  var main = document.getElementById('MainImage');

  function usd(c) { return '$' + (c / 100).toFixed(2); }
  function bs(c) {
    return 'Bs. ' + ((c / 100) * rate).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function selected() {
    var out = [];
    form.querySelectorAll('fieldset[data-opt]').forEach(function (f) {
      var c = f.querySelector('input:checked');
      out.push(c ? c.value : null);
    });
    return out;
  }
  function find() {
    var sel = selected();
    return data.variants.filter(function (v) {
      var vo = [v.option1, v.option2, v.option3];
      return sel.every(function (s, i) { return vo[i] === s; });
    })[0];
  }
  function setImage(src) {
    var img = main && main.querySelector('img');
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
  }
  function update() {
    var v = find();
    if (!v) { btn.disabled = true; btn.textContent = 'No disponible'; return; }
    idInput.value = v.id;
    showStock(v.id);
    var html = '<span class="price__usd">' + usd(v.price) + '</span>' +
      (rate > 0 ? '<span class="price__bs">' + bs(v.price) + '</span>' : '');
    priceBox.innerHTML = html;
    if (barPrice) barPrice.innerHTML = html;
    btn.disabled = !v.available;
    btn.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
    if (v.featured_image && v.featured_image.src) setImage(v.featured_image.src);
    try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
  }
  var stock = {};
  try { stock = JSON.parse(document.getElementById('StockJSON').textContent); } catch (e) {}
  var note = document.getElementById('StockNote');
  function showStock(id) {
    if (!note) return;
    var q = stock[id];
    if (q) { note.textContent = q === 1 ? 'Queda solo 1 unidad' : 'Quedan solo ' + q + ' unidades'; note.hidden = false; }
    else { note.hidden = true; }
  }
  showStock(idInput.value);
  form.addEventListener('change', update);
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () { setImage(t.getAttribute('data-src')); });
  });
})();

(function () {
  var data = document.getElementById('CartJSON');
  var btn = document.getElementById('SendWa');
  if (!data || !btn) return;
  var cart = JSON.parse(data.textContent);
  var ids = ['d-nombre', 'd-ci', 'd-tel', 'd-estado', 'd-ciudad', 'd-dir'];
  var err = document.getElementById('DeliveryErr');
  var KEY = 'relivon-datos-entrega';
  function val(id) { return document.getElementById(id).value.trim(); }

  try {
    var saved = JSON.parse(localStorage.getItem(KEY) || '{}');
    ids.forEach(function (id) { if (saved[id]) document.getElementById(id).value = saved[id]; });
  } catch (e) {}

  btn.addEventListener('click', function (e) {
    var missing = ids.some(function (id) { return !val(id); });
    if (missing) {
      e.preventDefault();
      err.textContent = 'Completa todos los datos de entrega para poder enviar tu pedido.';
      return;
    }
    err.textContent = '';
    try {
      var s = {}; ids.forEach(function (id) { s[id] = val(id); });
      localStorage.setItem(KEY, JSON.stringify(s));
    } catch (x) {}
    var lines = cart.items.map(function (i) {
      return '• ' + i.qty + ' x ' + i.title + (i.isDefault ? '' : ' (' + i.variant + ')') + ' — ' + i.line;
    });
    var msg = 'Hola Relivon, quiero hacer este pedido:\n\n' + lines.join('\n') +
      '\n\nTotal: ' + cart.total + (cart.totalBs ? ' (Bs. ' + cart.totalBs + ' a tasa BCV)' : ' (a tasa BCV del día)') +
      '\nPago: Pago Móvil al recibir\nEnvío: Tealca' +
      '\n\nDatos de entrega\nNombre: ' + val('d-nombre') + '\nCédula: ' + val('d-ci') + '\nTeléfono: ' + val('d-tel') +
      '\nEstado: ' + val('d-estado') + '\nCiudad: ' + val('d-ciudad') + '\nDirección: ' + val('d-dir');
    btn.href = 'https://wa.me/' + (cart.whatsapp || '584248484077') + '?text=' + encodeURIComponent(msg);
  });

  var cartForm = document.getElementById('cart');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'updates[]') cartForm.submit();
    });
  }
})();

/* Ordena la descripción del producto aunque se haya pegado como texto simple */
(function () {
  var desc = document.querySelector('.desc');
  if (!desc || desc.querySelector('ul,ol,h1,h2,h3,h4')) return;
  var raw = [];
  Array.prototype.forEach.call(desc.childNodes, function (n) {
    var t = (n.nodeType === 1 ? (n.innerText || n.textContent) : n.textContent) || '';
    t.split(/\r?\n/).forEach(function (l) {
      l = l.replace(/ /g, ' ').trim();
      if (l) raw.push(l);
    });
  });
  if (raw.length < 3) return;

  function isHeading(l) {
    return l.length <= 42 && !/[.:!?]$/.test(l) && !/:/.test(l) && !/^([•·*\-–]|\d+[.)])\s*/.test(l);
  }
  var out = document.createElement('div');
  out.className = 'pinfo';
  var card = null, list = null, listKind = '';
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined) e.textContent = text;
    return e;
  }
  function newCard(title) {
    card = el('section', 'pcard');
    card.appendChild(el('h3', '', title));
    out.appendChild(card);
    list = null; listKind = '';
  }
  function ensureList(kind) {
    if (list && listKind === kind) return list;
    list = kind === 'specs' ? el('dl', 'specs') : kind === 'nums' ? el('ol', 'nums') : el('ul', 'checks');
    listKind = kind;
    if (!card) newCard('Información');
    card.appendChild(list);
    return list;
  }

  raw.forEach(function (l) {
    var m;
    if ((m = l.match(/^(\d+)[.)]\s*(.+)$/))) {
      ensureList('nums').appendChild(el('li', '', m[2]));
    } else if ((m = l.match(/^[•·*\-–]\s*(.+)$/))) {
      var t = m[1], sp = t.match(/^([^:]{2,28}):\s*(.+)$/);
      if (sp) {
        var row = el('div');
        row.appendChild(el('dt', '', sp[1]));
        row.appendChild(el('dd', '', sp[2]));
        ensureList('specs').appendChild(row);
      } else {
        ensureList('checks').appendChild(el('li', '', t));
      }
    } else if (isHeading(l)) {
      newCard(l);
    } else if ((m = l.match(/^(Nota de seguridad|Recomendación de seguridad|Importante):\s*(.+)$/))) {
      var n = el('p', 'pnote'), b = el('b', '', m[1] + ': ');
      n.appendChild(b); n.appendChild(document.createTextNode(m[2]));
      out.appendChild(n); card = null; list = null;
    } else {
      list = null; listKind = '';
      if (card) card.appendChild(el('p', '', l));
      else out.appendChild(el('p', 'pintro', l));
    }
  });
  desc.textContent = '';
  desc.appendChild(out);
  desc.classList.add('is-rich');
})();
